import { CircularProgress } from '@material-ui/core';
import { Color } from 'core';
import React from 'react';
import styled from 'styled-components';

interface LoadingModalProps {
  message?: string;
}

export const LoadingModal = ({ message = 'Loading...' }: LoadingModalProps) => {
  return (
    <ModalBackdrop>
      <ModalContainer>
        <CircularProgress size={48} />
        <LoadingMessage>{message}</LoadingMessage>
      </ModalContainer>
    </ModalBackdrop>
  );
};

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const LoadingMessage = styled.p`
  margin: 0;
  font-size: 18px;
  color: ${Color.darkGray};
`;
